'use client';

import { useLayoutEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Shown while the society for the current URL is being resolved. Uses the
 * same video backdrop as `/search` and the not-found page so the transition
 * between states feels continuous, and — critically — stops the previous
 * society's page content (and its `document.title` effect) from painting
 * while the new lookup is in flight.
 */
export default function SocietyLoadingScreen() {
  useLayoutEffect(() => {
    document.title = 'Loading… - BreedLOGIC';
  }, []);

  return (
    <Box
      component="section"
      aria-busy="true"
      aria-live="polite"
      sx={{
        position: 'relative',
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
      }}
    >
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        src="/images/background.mp4"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 56%',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress sx={{ color: 'common.white' }} />
      </Box>
    </Box>
  );
}
